import React, { useState, useEffect } from 'react';

// Режим отображения лого в круглой «монете»:
// - полнокадровый тайл (BBVA, Naranja X) → cover, кроп в круг
// - круглое лого (BNA+, Personal Pay): прозрачные углы, но сам круг достаёт
//   до середин рёбер → cover, чтобы круг заполнил монету без пустого поля
// - прозрачный знак с отступом (Santander, Mercado Pago) → contain
// Определяется по альфе углов и середин рёбер через canvas, кэш по src.
const modeCache = new Map();

const detectMode = (img) => {
    const ratio = img.naturalWidth / img.naturalHeight;
    // Заметно не квадратные лого кропить нельзя
    if (ratio < 0.85 || ratio > 1.18) return 'contain';
    try {
        const size = 32;
        const canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, size, size);
        const alphaAt = (x, y) => ctx.getImageData(x, y, 1, 1).data[3];
        const mid = Math.floor(size / 2);
        const corners = [[1, 1], [size - 2, 1], [1, size - 2], [size - 2, size - 2]];
        const edges = [[mid, 1], [mid, size - 2], [1, mid], [size - 2, mid]];
        const cornerTransparent = corners.filter(([x, y]) => alphaAt(x, y) < 40).length;
        const edgeOpaque = edges.filter(([x, y]) => alphaAt(x, y) >= 180).length;
        // Полнокадровый прямоугольный тайл: углы непрозрачны → cover
        if (cornerTransparent < 2) return 'cover';
        // Круглое лого: углы прозрачны, но контур круга достаёт до середин
        // рёбер (≥3 из 4 непрозрачны) → cover, заполняем монету целиком
        if (edgeOpaque >= 3) return 'cover';
        // Прозрачный знак/wordmark с отступами → contain
        return 'contain';
    } catch (err) {
        // canvas недоступен/чужой origin — безопасный режим
        return 'contain';
    }
};

export default function BankLogo({ src, alt = '', className }) {
    const [mode, setMode] = useState(() => modeCache.get(src) || null);

    useEffect(() => {
        setMode(modeCache.get(src) || null);
    }, [src]);

    const handleLoad = (e) => {
        let result = modeCache.get(src);
        if (!result) {
            result = detectMode(e.target);
            modeCache.set(src, result);
        }
        setMode(result);
    };

    // До определения — contain: лучше маленький знак, чем мелькнувший обрезанный
    return <img src={src} alt={alt} className={className} data-fit={mode || 'contain'} onLoad={handleLoad} />;
}
